export default function trailerModal() {
    if(document.querySelector(".modal-trailer")) {
        let trailers = document.querySelectorAll(".movies__trailer div");
        let modalTrailer = document.querySelector(".modal-trailer .modal__content iframe");
        let modalBg = document.querySelector(".modal-trailer .modal__bg");
        let modalClose = document.querySelector(".modal-trailer .modal__close");
    
        trailers.forEach(trailer => {
            trailer.addEventListener("click", () => {
                let trailerItem = trailer.dataset.iframe;
    
                modalTrailer.src = trailerItem;
            });
        });
    
        modalBg.addEventListener("click", () => {
            modalTrailer.src = "";
        });
    
        modalClose.addEventListener("click", () => {
            modalTrailer.src = "";
        });
    }
}